






































































































































































































































































































































































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import Chart, { ChartOptions } from "chart.js";
import { jsPDF } from "jspdf";
import {  BPopover } from "bootstrap-vue";

@Component({
  components: { Header, EntityTabs,BPopover },
  computed: mapState("gaps", [
    "measureTypes",
    "status",
    "subStatus",
    "closeReasons",
    "priority",
    "campaigns",
    "filter",
  ]),
  ...mapState("auth", ["user"]),
})
export default class Summary extends Vue {
  user!: any;
  showTitleReport: boolean = false;
  summary: Array<any> = [];
  summaryCount: Array<any> = [];
  //campaigns: Array<any> = [];
  measureTypes!: Array<any>;
  status!: Array<any>;
  subStatus!: Array<any>;
  closeReasons!: Array<any>;
  summaryPriorities: Array<any> = [];
  summaryCategories: Array<any> = [];
  noContactSummary: Array<any> = [];
  //gap Count
  summaryGapCountPriorities: Array<any> = [];
  summaryCalls: Array<any> = [];
  summaryNoContactMembers: Array<any> = [];
  summaryContactMembers: Array<any> = [];
  summaryContactMemberStatus: Array<any> = [];
  summaryContactNoContactMembers: Array<any> = [];
  campaignId: string = "";

  //chart
  chartPriorities: Array<any> = [];
  chart: any = {
    CONTACT_NO_CONTACT: null,
    NO_CONTACT: null,
    CONTACT_REASONS: null,
  };

  @Watch("filter", { deep: true })
  onFilterChanged() {
    this.campaignId = "";
    this.getSummary();
  }

  async getSummary() {
    this.$store.commit("main/SET_LOADING", true);
    const { campaignId } = this;
    try {
      this.summary = await this.$store.dispatch("gaps/getSummary", {
        campaignId,
      });

      // SET CHARTS
      //await this.setCharts();
      this.setGapCount();
      //
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async setGapCount() {
    this.summaryPriorities = [];
    this.summaryCalls = [];
    this.summaryContactMembers = [];
    this.summaryNoContactMembers = [];
    this.summaryCategories = [];
    this.summaryContactMemberStatus = [];
    this.chartPriorities = [];
    var categories: Array<any> = [];

    Chart.plugins.register({
      beforeDraw: function (chartInstance) {
        var ctx = chartInstance["chart"].ctx;
        ctx.fillStyle = "white";
        ctx.fillRect(
          null,
          null,
          chartInstance["chart"].width,
          chartInstance["chart"].height
        );
      },
    });

    this.summaryPriorities = this.summary
      .map((s) => s.Priority)
      .filter((v, i, a) => a.indexOf(v) === i);

    this.chartPriorities = await this.getPriorities(3);

    categories = this.summary
      .map((s) => s.Category)
      .filter((v, i, a) => a.indexOf(v) === i);

    var reasons = this.summary
      .map((s) => s.GReason)
      .filter((v, i, a) => a.indexOf(v) === i);

    //Contact / No Contact
    //x2= categories;
    var grandTotalObj = {};
    for (const [index, c] of categories.entries()) {
      const items = this.summary.filter((s) => s.Category === c);

      var summaryObj = {};

      for (const priority of this.summaryPriorities) {
        const gaps = items
          .filter((item) => item.Priority === priority)
          .map((i) => i.Gaps)
          .reduce((accumulator, value) => accumulator + value, 0);

        summaryObj[priority] = gaps;
        grandTotalObj[priority] = grandTotalObj[priority]
          ? grandTotalObj[priority] + gaps
          : gaps;
      }

      if (items.length) {
        total = Object.keys(summaryObj).reduce(
          (sum, key) => sum + parseFloat(summaryObj[key] || 0),
          0
        );
        summaryObj["total"] = total;
        this.summaryCategories.push({ c, ...summaryObj });
      }

      if (index === categories.length - 1) {
        total = Object.keys(grandTotalObj).reduce(
          (sum, key) => sum + parseFloat(grandTotalObj[key] || 0),
          0
        );
        grandTotalObj["total"] = total;
        this.summaryCategories.push({ GrandTotal: "TOTAL", ...grandTotalObj });
      }
    }

    // summary No Contact Members
    grandTotalObj = {};
    for (const [index, r] of reasons.entries()) {
      const items = this.summary.filter(
        (s) => s.GReason === r && s.Category === "NO CONTACT"
      );

      summaryObj = {};

      for (const priority of this.summaryPriorities) {
        const gaps = items
          .filter((item) => item.Priority === priority)
          .map((i) => i.Gaps)
          .reduce((accumulator, value) => accumulator + value, 0);
        summaryObj[priority] = gaps;
        grandTotalObj[priority] = grandTotalObj[priority]
          ? grandTotalObj[priority] + gaps
          : gaps;
      }

      if (items.length) {
        total = Object.keys(summaryObj).reduce(
          (sum, key) => sum + parseFloat(summaryObj[key] || 0),
          0
        );
        summaryObj["total"] = total;
        this.summaryNoContactMembers.push({ r, ...summaryObj });
      }

      if (index === reasons.length - 1) {
        total = Object.keys(grandTotalObj).reduce(
          (sum, key) => sum + parseFloat(grandTotalObj[key] || 0),
          0
        );
        grandTotalObj["total"] = total;
        this.summaryNoContactMembers.push({
          GrandTotal: "TOTAL",
          ...grandTotalObj,
        });
      }
    }

    // summary  Contact Members by Status
    const statuses = this.summary
      .map((s) => s.GSubStatus)
      .filter((v, i, a) => a.indexOf(v) === i);

    grandTotalObj = {};
    for (const [index, status] of statuses.entries()) {
      const items = this.summary.filter(
        (s) => s.GSubStatus === status && s.Category === "CONTACT"
      );

      summaryObj = {};

      for (const priority of this.summaryPriorities) {
        const gaps = items
          .filter((item) => item.Priority === priority)
          .map((i) => i.Gaps)
          .reduce((accumulator, value) => accumulator + value, 0);
        summaryObj[priority] = gaps;
        grandTotalObj[priority] = grandTotalObj[priority]
          ? grandTotalObj[priority] + gaps
          : gaps;
      }

      if (items.length) {
        total = Object.keys(summaryObj).reduce(
          (sum, key) => sum + parseFloat(summaryObj[key] || 0),
          0
        );
        summaryObj["total"] = total;
        this.summaryContactMemberStatus.push({ status, ...summaryObj });
      }
      if (index === statuses.length - 1) {
        total = Object.keys(grandTotalObj).reduce(
          (sum, key) => sum + parseFloat(grandTotalObj[key] || 0),
          0
        );
        grandTotalObj["total"] = total;
        this.summaryContactMemberStatus.push({
          GrandTotal: "TOTAL",
          ...grandTotalObj,
        });
      }
    }

    // summary  Contact Members by Reasons
    grandTotalObj = {};
    for (const [index, r] of reasons.entries()) {
      const items = this.summary.filter(
        (s) => s.GReason === r && s.Category === "CONTACT"
      );

      summaryObj = {};

      for (const priority of this.summaryPriorities) {
        const gaps = items
          .filter((item) => item.Priority === priority)
          .map((i) => i.Gaps)
          .reduce((accumulator, value) => accumulator + value, 0);
        summaryObj[priority] = gaps;
        grandTotalObj[priority] = grandTotalObj[priority]
          ? grandTotalObj[priority] + gaps
          : gaps;
      }

      if (items.length) {
        total = Object.keys(summaryObj).reduce(
          (sum, key) => sum + parseFloat(summaryObj[key] || 0),
          0
        );
        summaryObj["total"] = total;
        this.summaryContactMembers.push({ r, ...summaryObj });
      }
      if (index === reasons.length - 1) {
        total = Object.keys(grandTotalObj).reduce(
          (sum, key) => sum + parseFloat(grandTotalObj[key] || 0),
          0
        );
        grandTotalObj["total"] = total;
        this.summaryContactMembers.push({
          GrandTotal: "TOTAL",
          ...grandTotalObj,
        });
      }
    }

    //set chars

    var type = "bar";
    const options: ChartOptions = {
      title: {
        display: false,
      },
      legend: {
        display: true,
        position: "left",
        labels: {
          fontSize: 14,
        },
      },
    };
    const backgroundColor = [
      "rgb(255, 99, 132)",
      "rgb(54, 162, 235)",
      "rgb(255, 205, 86)",
      "rgba(255, 159, 64)",
      "rgba(255, 205, 86)",
      "rgba(75, 192, 192)",
      "rgba(54, 162, 235)",
      "rgba(153, 102, 255)",
      "rgba(201, 203, 207)",
      "#00b0d3",
      "#2541b2",
      "#007991",
      "#217cc8",
      "#03256c",
      "#217cc8",
    ];

    const borderWidth = 1;

    //Char CONTAC / NO CONTAC
    var datasets: any = [];
    var categoryTemp: any = {};
    var priorityTemp: any = {};
    var reportTemp: any = {};

    let x = 0;
    for (var prop2 in this.summaryPriorities) {
      var objDataset: any = {
        label: "",
        data: [],
        backgroundColor: [],
        borderWidth: 1,
      };

      var data: any = [];
      var priority = this.summaryPriorities[prop2];
      var p = this.summary.filter((s) => s.Priority === priority);

      for (var cProp in categories) {
        //var category =  categories[cProp];
        var total: any = p
          .filter((p) => p.Category === categories[cProp])
          .reduce(function (accumulator, p) {
            return accumulator + p.Gaps;
          }, 0);

        data.push(total);
      }

      objDataset.label = priority;
      objDataset.data = data;
      objDataset.backgroundColor = backgroundColor[x];
      datasets.push(objDataset);
      x++;
    }

    let canvas: any = document.getElementById("CONTACT_NO_CONTACT");
    let context = canvas.getContext("2d");

    //PDF REPORT
    let pdf_canvas: any = document.getElementById("PDF_CONTACT_NO_CONTACT");
    let pdf_context = pdf_canvas.getContext("2d");

    if (this.chart.CONTACT_NO_CONTACT) {
      this.chart.CONTACT_NO_CONTACT.destroy();
    }

    if (this.chart.PDF_CONTACT_NO_CONTACT) {
      this.chart.PDF_CONTACT_NO_CONTACT.destroy();
    }

    this.chart.CONTACT_NO_CONTACT = new Chart(context, {
      type,
      data: {
        labels: categories,
        datasets: datasets,
      },
      options,
    });

    this.chart.PDF_CONTACT_NO_CONTACT = new Chart(pdf_context, {
      type,
      data: {
        labels: categories,
        datasets: datasets,
      },
      options,
    });

    //Char NO CONTAC
    /* const statuses = this.summary
      .map((s) => s.GSubStatus)
      .filter((v, i, a) => a.indexOf(v) === i);*/

    reasons = this.summary
      //.map((s) => s.GReason)
      .filter((v) => v.Category === "NO CONTACT")
      .map((s) => s.GReason)
      .filter((v, i, a) => a.indexOf(v) === i);

    for (const r of reasons) {
      var t = this.summary;
      //const items3 = this.summary.filter((r2) => r2.Category === "NO CONTACT");
      const items2 = this.summary.filter(
        (r2) => r2.GReason === r && r2.Category === "NO CONTACT"
      );

      var noContactSummaryObj = {};

      for (const priority of this.summaryPriorities) {
        const gaps = items2
          .filter((item) => item.Priority === priority)
          .map((i) => i.Gaps)
          .reduce((accumulator, value) => accumulator + value, 0);
        noContactSummaryObj[priority] = gaps;
      }

      if (items2.length) {
        this.noContactSummary.push({ r, ...noContactSummaryObj });
      }
    }
    //

    //set data

    datasets = [];
    x = 0;
    for (const priority of this.summaryPriorities) {
      data = [];
      objDataset = {
        label: priority,
        data: [],
        backgroundColor: [],
        borderWidth: 1,
      };

      const gaps = this.noContactSummary.map((item) => item[priority]);

      objDataset.data = gaps;
      objDataset.backgroundColor = backgroundColor[x];
      datasets.push(objDataset);
      x++;
    }

    //end set data

    //set chart
    canvas = document.getElementById("NO_CONTACT");
    context = canvas.getContext("2d");

    //PDF
    pdf_canvas = document.getElementById("PDF_NO_CONTACT");
    pdf_context = pdf_canvas.getContext("2d");

    if (this.chart.NO_CONTACT) {
      this.chart.NO_CONTACT.destroy();
    }

    if (this.chart.PDF_NO_CONTACT) {
      this.chart.PDF_NO_CONTACT.destroy();
    }

    this.chart.NO_CONTACT = new Chart(context, {
      type,
      data: {
        labels: reasons,
        datasets: datasets,
      },
      options,
    });

    this.chart.PDF_NO_CONTACT = new Chart(pdf_context, {
      type,
      data: {
        labels: reasons,
        datasets: datasets,
      },
      options,
    });

    //end chart

    //this.setCharts();

    //summary chart

    // SET STATUS SUMMARY

    await Vue.nextTick();

    const summaryStatus: any = [];

    for (const stat of statuses) {
      const items = this.summary.filter(
        (s) => s.GSubStatus === stat //&& s.Category === "CONTACT"
      );

      summaryObj = {};

      for (const priority of this.chartPriorities) {
        const gaps = items
          .filter((item) => item.Priority === priority)
          .map((i) => i.Gaps)
          .reduce((accumulator, value) => accumulator + value, 0);
        summaryObj[priority] = gaps;
      }

      if (items.length) {
        summaryStatus.push({ stat, ...summaryObj });
      }
    }

    type = "doughnut";

    for (const priority of this.chartPriorities) {
      canvas = document.getElementById("PRIORITY_" + priority);
      context = canvas.getContext("2d");

      //PDF
      pdf_canvas = document.getElementById("PDF_PRIORITY_" + priority);
      pdf_context = pdf_canvas.getContext("2d");

      if (this.chart["PRIORITY_" + priority]) {
        this.chart["PRIORITY_" + priority].destroy();
      }

      if (this.chart["PDF_PRIORITY_" + priority]) {
        this.chart["PDF_PRIORITY_" + priority].destroy();
      }

      this.chart["PRIORITY_" + priority] = new Chart(context, {
        type,
        data: {
          labels: summaryStatus
            .filter((item) => item[priority])
            .map((s) => s.stat),
          datasets: [
            {
              label: priority,
              data: summaryStatus
                .filter((item) => item[priority])
                .map((s) => s[priority]), //[300, 50, 100],
              backgroundColor,
              //hoverOffset: 4
            },
          ],
        },
        options,
      });

      this.chart["PDF_PRIORITY_" + priority] = new Chart(pdf_context, {
        type,
        data: {
          labels: summaryStatus
            .filter((item) => item[priority])
            .map((s) => s.stat),
          datasets: [
            {
              label: priority,
              data: summaryStatus
                .filter((item) => item[priority])
                .map((s) => s[priority]), //[300, 50, 100],
              backgroundColor,
              //hoverOffset: 4
            },
          ],
        },
        options,
      });
    }

    //SUMMARY PRIORITY
    const priotityStatus = this.summary
      .map((s) => s.GStatus)
      .filter((v, i, a) => a.indexOf(v) === i);

    const summaryPriorities: any = [];

    for (const status of priotityStatus) {
      const gaps = this.summary
        .filter((item) => item.GStatus === status)
        .map((i) => i.Gaps)
        .reduce((accumulator, value) => accumulator + value, 0);
      summaryPriorities.push(gaps);
    }

    //type = "bar";
    if (this.chart.PRIORITY_SUMMARY) {
      this.chart.PRIORITY_SUMMARY.destroy();
    }

    if (this.chart.PDF_PRIORITY_SUMMARY) {
      this.chart.PRIORITY_SUMMARY.destroy();
    }

    canvas = document.getElementById("PRIORITY_SUMMARY");
    context = canvas.getContext("2d");

    //PDF
    pdf_canvas = document.getElementById("PDF_PRIORITY_SUMMARY");
    pdf_context = pdf_canvas.getContext("2d");

    this.chart.PRIORITY_SUMMARY = new Chart(context, {
      type,
      data: {
        labels: priotityStatus,
        datasets: [
          {
            label: "",
            data: summaryPriorities, //[300, 50, 100],
            backgroundColor,
            //hoverOffset: 4
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: true,
          position: "left",
          labels: {
            fontSize: 14,
          },
        },
      },
    });

    this.chart.PDF_PRIORITY_SUMMARY = new Chart(pdf_context, {
      type,
      data: {
        labels: priotityStatus,
        datasets: [
          {
            label: "",
            data: summaryPriorities, //[300, 50, 100],
            backgroundColor,
            //hoverOffset: 4
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: true,
          position: "left",
          labels: {
            fontSize: 14,
          },
        },
      },
    });

    //CONTACT BY ACTIVITY
    type = "line";

    const summaryActivity: any = [];
    const status = this.summaryContactMemberStatus.map((s) => s.status);

    for (const sta of status) {
      const staObj = this.summaryContactMemberStatus.filter(
        (item) => item.status === sta
      )[0];
      /*const gaps = this.summaryContactMemberStatus
        .filter((item) => item.status === sta)
        .map((i) => i.Gaps)
        .reduce((accumulator, value) => accumulator + value, 0);*/
      var gaps = 0;
      for (const st in staObj) {
        if (st != "status") gaps += staObj[st];
      }
      summaryActivity.push(gaps);
    }

    canvas = document.getElementById("CONTACT_ACTIVITY");
    context = canvas.getContext("2d");
    //pdf
    pdf_canvas = document.getElementById("PDF_CONTACT_ACTIVITY");
    pdf_context = pdf_canvas.getContext("2d");

    if (this.chart.CONTACT_ACTIVITY) {
      this.chart.CONTACT_ACTIVITY.destroy();
    }

    if (this.chart.PDF_CONTACT_ACTIVITY) {
      this.chart.PDF_CONTACT_ACTIVITY.destroy();
    }

    this.chart.CONTACT_ACTIVITY = new Chart(context, {
      type,
      data: {
        labels: this.summaryContactMemberStatus.map((s) => s.status),
        datasets: [
          {
            label: "",
            data: summaryActivity,
            fill: false,
            borderColor: "rgb(75, 192, 192)",
            // tension: 0.1
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: false,
          position: "left",
          labels: {
            fontSize: 14,
          },
        },
      },
    });

    this.chart.PDF_CONTACT_ACTIVITY = new Chart(pdf_context, {
      type,
      data: {
        labels: this.summaryContactMemberStatus.map((s) => s.status),
        datasets: [
          {
            label: "",
            data: summaryActivity,
            fill: false,
            borderColor: "rgb(75, 192, 192)",
            // tension: 0.1
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: false,
          position: "left",
          labels: {
            fontSize: 14,
          },
        },
      },
    });

    //Contact by Reasons
    type = "bar";
    const summaryReasons: any = [];
    reasons = this.summaryContactMembers.map((m) => m.r);

    for (const reason of reasons) {
      const reasonObj = this.summaryContactMembers.filter(
        (item) => item.r === reason
      )[0];

      gaps = 0;
      for (const prop in reasonObj) {
        if (prop != "r") gaps += reasonObj[prop];
      }
      summaryReasons.push(gaps);
    }

    canvas = document.getElementById("CONTACT_REASONS");
    context = canvas.getContext("2d");
    //PDF
    pdf_canvas = document.getElementById("PDF_CONTACT_REASONS");
    pdf_context = pdf_canvas.getContext("2d");

    if (this.chart.CONTACT_REASONS) {
      this.chart.CONTACT_REASONS.destroy();
    }

    if (this.chart.PDF_CONTACT_REASONS) {
      this.chart.PDF_CONTACT_REASONS.destroy();
    }

    this.chart.CONTACT_REASONS = new Chart(context, {
      type,
      data: {
        labels: reasons,
        datasets: [
          {
            label: "",
            data: summaryReasons,
            backgroundColor /* : [
              "rgba(255, 99, 132, 0.2)",
              "rgba(255, 159, 64, 0.2)",
              "rgba(255, 205, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(201, 203, 207, 0.2)",
            ] */,
            borderColor: [
              "rgb(255, 99, 132)",
              "rgb(255, 159, 64)",
              "rgb(255, 205, 86)",
              "rgb(75, 192, 192)",
              "rgb(54, 162, 235)",
              "rgb(153, 102, 255)",
              "rgb(201, 203, 207)",
            ],
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: false,
          position: "left",
          labels: {
            fontSize: 14,
          },
        },
      },
    });

    this.chart.PDF_CONTACT_REASONS = new Chart(pdf_context, {
      type,
      data: {
        labels: reasons,
        datasets: [
          {
            label: "",
            data: summaryReasons,
            backgroundColor /* : [
              "rgba(255, 99, 132, 0.2)",
              "rgba(255, 159, 64, 0.2)",
              "rgba(255, 205, 86, 0.2)",
              "rgba(75, 192, 192, 0.2)",
              "rgba(54, 162, 235, 0.2)",
              "rgba(153, 102, 255, 0.2)",
              "rgba(201, 203, 207, 0.2)",
            ] */,
            borderColor: [
              "rgb(255, 99, 132)",
              "rgb(255, 159, 64)",
              "rgb(255, 205, 86)",
              "rgb(75, 192, 192)",
              "rgb(54, 162, 235)",
              "rgb(153, 102, 255)",
              "rgb(201, 203, 207)",
            ],
          },
        ],
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: false,
          position: "left",
          labels: {
            fontSize: 14,
          },
        },
      },
    });
    //END
  }
  async setCharts() {
    //this.chartPriorities = await this.getPriorities(3);
    const type = "doughnut";
    const options: ChartOptions = {
      title: {
        display: false,
      },
      legend: {
        display: true,
        position: "left",
        labels: {
          fontSize: 14,
        },
      },
    };
    const backgroundColor = [
      "#00b0d3",
      "#2541b2",
      "#007991",
      "#217cc8",
      "#03256c",
      "#217cc8",
    ];

    const borderWidth = 1;

    let canvas: any = document.getElementById("PRIORITY_CKD3");
    let context = canvas.getContext("2d");
    let chart = new Chart(context, {
      type,
      data: {
        labels: ["Red", "Blue", "Yellow"],
        datasets: [
          {
            label: "My First Dataset",
            data: [300, 50, 100],
            backgroundColor: [
              "rgb(255, 99, 132)",
              "rgb(54, 162, 235)",
              "rgb(255, 205, 86)",
            ],
            //hoverOffset: 4
          },
        ],
      },
      options,
    });
  }
  getPriorities(limit) {
    return this.summaryPriorities.filter((v, i, a) => i < limit);
  }

  async exportPDF() {
    this.$store.commit("main/SET_LOADING", true);
    //const entity = this.$store.state.auth.user;

    /*     var options = {
      //background: '#fff',
      pagesplit: true,
    }; */

    // this.showTitleReport = true;

    var el = document.getElementById("report")!;
    const scale = 0.8;
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: [el.offsetWidth * scale, el.offsetHeight * scale + 50], //10
      //format: [2114 * scale, 2314 * scale + 200]
    });

    doc.html(el, {
      html2canvas: {
        scale,
      },
      //HTMLOptions:options,
      callback: (doc) => {
        doc.save(
          "summary_report_" + this.$moment().format("MMDDYYYY_hhmmA") + ".pdf"
        );
        this.$store.commit("main/SET_LOADING", false);
      },
      x: 0,
      y: 0,
    });
  }

  async exportExcel(detailed) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { campaignId } = this;
      const mime = "application/octet-stream";
      const data = await this.$store.dispatch("gaps/getSummaryExel", {
        campaignId,
        detailed,
      });
      const blob = new Blob([data], { type: mime });
      const timestamp = this.$moment().format("YYMMDD_HHmmss");
      const anchor = document.createElement("a");
      //anchor.download = `summary_report_${timestamp}.xlsx`;
      anchor.download = detailed ==true? `summary_report_datailed_${timestamp}.xlsx`:`summary_report_${timestamp}.xlsx`;
      anchor.href = window.URL.createObjectURL(blob);
      anchor.dataset.downloadurl = [mime, anchor.download, anchor.href].join(
        ":"
      );
      anchor.click();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

  get getEntity() {
    return this.$store.state.auth.user.entities.filter(
      (e) => e.id == this.$store.state.auth.entityId
    )[0];
  }

  get getCampaign() {
    return this.campaignId
      ? this.$store.state.gaps.campaigns.filter(
          (c) => c.id == this.campaignId
        )[0]
      : { name: "All" };
  }

   close(id) {
    this.$root.$emit("bv::hide::popover", id);
  }

  mounted() {
    this.getSummary();
  }
}
